import { mutatorAction } from "satcheljs";
import muteScheduleGroupDialogStore from "../store/store";

/**
 * Hides the mute/unmute schedule group confirmation dialog
 */
const hideMuteScheduleGroupDialog = mutatorAction(
    "hideMuteScheduleGroupDialog",
    () => {
        muteScheduleGroupDialogStore().isShown = false;
        muteScheduleGroupDialogStore().actionTaken = null;
        muteScheduleGroupDialogStore().onConfirm = null;
        muteScheduleGroupDialogStore().onCancel = null;
    }
);

export default hideMuteScheduleGroupDialog;
